import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

/**
 * Club Room Carousel Component
 * Handles the featured room carousel on the Rooms archive page
 */
export default class ClubRoomCarousel {
  constructor(element) {
    this.element = element;
    this.carousel = element.querySelector('[data-club-room-carousel]');
    
    if (!this.carousel) {
      console.warn('Club Room carousel element not found');
      return;
    }
    
    // Navigation elements
    this.prevBtn = element.querySelector('.rooms-archive__club-room-arrow--prev');
    this.nextBtn = element.querySelector('.rooms-archive__club-room-arrow--next');
    this.currentCounter = element.querySelector('.current-slide');
    this.totalCounter = element.querySelector('.total-slides');
    
    this.flickity = null;
    
    this.init();
  }

  init() {
    // Check if there are any slides
    const slides = this.carousel.querySelectorAll('.rooms-archive__club-room-slide');
    
    if (slides.length === 0) {
      console.warn('No slides found in Club Room carousel');
      return;
    }
    
    // Initialize Flickity
    this.flickity = new Flickity(this.carousel, {
      cellAlign: 'left',
      cellSelector: '.rooms-archive__club-room-slide',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      imagesLoaded: true,
      selectedAttraction: 0.1,
      friction: 0.8,
    });
    
    // Bind custom controls
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.flickity.previous();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.flickity.next();
      });
    }
    
    // Update counter on change
    this.flickity.on('change', (index) => {
      this.updateCounter(index);
    });
    
    // Initialize counter
    this.updateCounter(0);
  }
  
  updateCounter(index) {
    if (this.currentCounter) {
      this.currentCounter.textContent = index + 1;
    }
  }
  
  destroy() {
    if (this.flickity) {
      this.flickity.destroy();
    }
  }
}
